import { useToday } from "./useToday";

export function useYearProgress() {
  const { today } = useToday();
  
  // Oblicz początek roku
  const startOfYear = today.startOf("year");
  // Oblicz koniec roku
  const endOfYear = today.endOf("year");
  
  // Oblicz ile dni minęło od początku roku
  const daysPassed = today.diff(startOfYear, "day");
  // Oblicz całkowitą liczbę dni w roku
  const totalDays = endOfYear.diff(startOfYear, "day") + 1;
  
  // Oblicz procent
  const percentage = Math.round((daysPassed / totalDays) * 100 * 100) / 100; // Zaokrąglenie do 2 miejsc po przecinku
  
  return {
    percentage,
    daysPassed,
    totalDays,
  };
}

